import { LoginModalActionsCallback } from 'src/logic/main/services/watchLoginModalActions';
import PostalKit from '../../ports-frontend/PostalKit';

import { createLogger } from '../utils/logger';
const logger = createLogger('login.unity');

export async function loginOpen() {
  await PostalKit.publishEvent({
    channel: 'pam',
    topic: 'events',
    data: { event: 'pam.event.login.open' },
  });
}

export async function loginWatcher({
  callback,
}: {
  callback: LoginModalActionsCallback;
}) {
  const unsubscribeLoginModalCloseSubscribtion = await PostalKit.onSubscribe(
    (payload: { event: string }) => {
      logger.log(payload.event);

      if (
        payload.event === 'pam.callback.login.closed' ||
        payload.event === 'pam.callback.register.closed'
      ) {
        return callback({
          type: 'LOGIN_MODAL_STATE_CLOSED',
          data: {},
        });
      }
    },
    ['events', 'pam']
  );

  return () => {
    unsubscribeLoginModalCloseSubscribtion();
  };
}
